import { Injectable } from '@angular/core';
import { BaseAuthService, BaseUser } from '@shared/utils/base-auth';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockBaseAuthService extends BaseAuthService {
  constructor() {
    super();
  }

  getToken(): Promise<string> {
    throw new Error('Method not implemented.');
  }

  logout(): void {}

  getCurrentBaseUser(): Observable<BaseUser | undefined> {
    return of(
      new BaseUser(
        'demo@test.test',
        'a12f6e8c-6938-4746-9238-221d9190cdc7',
        'Super Administrator',
        'demo',
        'demo 2',
        'https://www.nicepng.com/png/full/810-8105444_male-placeholder.png'
      )
    );
  }
}
